import { Loader, LoadingOverlay } from "@mantine/core";
import React from "react";

function LoadingOverlayWithHint({
  visible,
  hint,
  ...props
}: {
  visible?: boolean;
  hint: string;
  [key: string]: any;
}) {
  return (
    <LoadingOverlay
      visible={visible ?? false}
      loader={
        <div className="flex flex-col items-center justify-center">
          <Loader />

          <div className="text-center mt-3 text-sm text-slate-500">{hint}</div>
        </div>
      }
      {...props}
    />
  );
}

export default LoadingOverlayWithHint;
